var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNote(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#cd24f5;opacity:0;}.b{fill:none;stroke:#cd24f5;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-29 12433)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-241 7)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 32,
    height: 32,
    rx: 4,
    transform: "translate(270 -12440)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(274.233 -12436.501)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.167,8a.4.4,0,0,1,.4.4",
    transform: "translate(3.601 4.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.917,8.4a.4.4,0,0,1,.4-.4",
    transform: "translate(3.451 4.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.317,8.65a.4.4,0,0,1-.4-.4",
    transform: "translate(3.451 4.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.567,8.25a.4.4,0,0,1-.4.4",
    transform: "translate(3.601 4.65)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.167,7.7V4.5",
    transform: "translate(3.601 2.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.368,10.1A9.6,9.6,0,1,0,9.848,19.509l1.92,4.992,1.92-4.992A9.6,9.6,0,0,0,21.368,10.1Z",
    transform: "translate(0 0)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.62812346b35bcb101b23efa82dcafde0.svg";
export { ForwardRef as ReactComponent };